import { useEffect, useState } from 'react';
import { Environment } from '../../../enviroment';
import { NovedadesItem } from '@esportal/portal-service';

const useNovedadesData = (novedadesType: 'club' | 'posventa'): NovedadesItem[] | null => {
	const [novedades, setNovedades] = useState<NovedadesItem[] | null>(null);

	const sortFilterEvents = (novedades: NovedadesItem[] | null): NovedadesItem[] | null => {
		if (!novedades) {
			return null;
		}

		const currentDate = new Date();

		const activeAndUpcomingEvents = [...novedades]
			.filter((event) => {
				const eventStartDate = event.startDate ? new Date(event.startDate) : null;
				const eventEndDate = new Date(event.endDate);

				const hasStarted = !eventStartDate || currentDate.getTime() >= eventStartDate.getTime();
				const hasNotEnded = currentDate.getTime() <= eventEndDate.getTime();

				return (
					hasStarted &&
					hasNotEnded &&
					((novedadesType === 'club' && event.club) || (novedadesType === 'posventa' && event.posventa))
				);
			})
			.sort((a, b) => {
				const dateA = new Date(a.endDate).getTime();
				const dateB = new Date(b.endDate).getTime();

				return dateA - dateB;
			});

		return activeAndUpcomingEvents;
	};

	useEffect(() => {
		const controller = new AbortController();

		const getNovedades = async () => {
			try {
				const novedadesUrl = Environment.getInstance().novedadesUrl;
				const response = await fetch(novedadesUrl, {
					signal: controller.signal,
				});

				const data = await response.json();

				setNovedades(sortFilterEvents(data.novedades as NovedadesItem[]));
			} catch (error) {
				if ((error as Error).name !== 'AbortError') {
					console.error(`Error fetching novedades: ${error}`);
				}
			}
		};

		getNovedades();

		return () => {
			controller.abort();
		};
	}, []);

	return novedades;
};

export default useNovedadesData;
